import { Injectable, inject } from '@angular/core';
import { Apollo, ApolloBase, gql } from 'apollo-angular';
import { BehaviorSubject, Subject, Observable, of, throwError } from 'rxjs';
import { catchError, finalize, map, shareReplay } from 'rxjs/operators';
import { PAGE_NODE } from '../../../../../graphQL/node-query-strings';

const PAGE_QUERY = gql`
  query PageByUri($uri: String!) {
    pageBy(uri: $uri) {
      ${PAGE_NODE}
    }
  }
`;

@Injectable({
    providedIn: 'root',
})
export class ApolloPageService {
    private readonly apollo: ApolloBase = inject(Apollo).use('cms');

    private readonly loadingSubject = new BehaviorSubject<boolean>(false);
    public readonly loading$ = this.loadingSubject.asObservable();

    private readonly errorSubject = new Subject<unknown>();
    public readonly error$ = this.errorSubject.asObservable();

    fetchPageByUri$(uri: string): Observable<any> {
        const cleaned = uri?.trim();
        if (!cleaned) return of(null);

        this.loadingSubject.next(true);

        return this.apollo
            .query<{ pageBy: any }>({
                query: PAGE_QUERY,
                variables: { uri: cleaned },
            })
            .pipe(
                map((result) => result.data?.pageBy ?? null),
                catchError((err) => {
                    this.errorSubject.next(err);
                    return throwError(() => err);
                }),
                finalize(() => this.loadingSubject.next(false)),
                shareReplay({ bufferSize: 1, refCount: false }),
            );
    }
}
